export { zh } from '@payloadcms/translations/languages/zh'
